import React from "react";
import "../StoragePages.scss";
import { Page } from "components/core/Page";
import { StorageHeader } from "components/storages/Header";
import { MILITARY_STORAGE_DATA } from "components/storages/ContentData/MilitaryStorageData";
import {
	BorderLine,
	Heading,
	Description,
	SubHeading,
	ListPoint,
	LastSearchBar
} from "components/storages/Common";
import Container from "components/core/Page/Container";
import { ScrollToTop } from "components/core/ScrollToTop";
import { useSelector } from "react-redux";

function MilitaryStoragePage() {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	return (
		<Page
			className="storage-page"
			title="Military Storage Facilities, Discounts & Rental Guide | Storage.com"
			description="From basic training to PCS, we've got you covered, 
			Storage.com offers storage units for every stage of your military 
			career. Book online in minutes!"
			canonical={`${baseUrl}/military-storage/`}
		>
			<Container>
				<StorageHeader
					heading="Find Military Storage Near You!"
					level="1"
				/>
				<div className="all-sections">
					{MILITARY_STORAGE_DATA?.map((item, index) => (
						<>
							<Heading
								content={item.heading}
								level="2"
							/>
							<Description desc={item.description} />

							{item.subHeadings &&
								item.subHeadings.map((subHeading) => (
									<>
										<SubHeading
											title={subHeading.title}
											level="3"
										/>

										{subHeading.descLink ? (
											<Description
												descLink={subHeading.descLink}
											/>
										) : (
											<Description
												desc={subHeading.desc}
											/>
										)}
									</>
								))}
							<ul>
								{item.points &&
									item.points.map((point) => (
										<ListPoint
											title={point.title}
											desc={point.desc}
										/>
									))}
							</ul>
							{index !== MILITARY_STORAGE_DATA.length - 1 && (
								<BorderLine />
							)}
						</>
					))}
					<LastSearchBar />
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default MilitaryStoragePage;
